/**
 * Inline SVG rendering of the cosow_ai gradient-S mark.
 * Must be inline (not <img>) so that the page font (Manrope) and inline
 * gradient both resolve correctly at small icon sizes.
 *
 * Extracted from DealWorkspace so the app shell's global module-chat rail item
 * can use it without importing the 5800-line page module.
 */

import * as React from 'react';

export function AiBrandIcon({ className }: { className?: string }) {
  const gradientId = React.useId();
  return (
    <svg
      viewBox="230 210 564 640"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgb(94, 235, 255)" />
          <stop offset="35%" stopColor="rgb(43, 116, 255)" />
          <stop offset="70%" stopColor="rgb(125, 49, 219)" />
          <stop offset="100%" stopColor="rgb(255, 45, 194)" />
        </linearGradient>
      </defs>
      <text
        x="512"
        y="594"
        dominantBaseline="middle"
        textAnchor="middle"
        fontFamily="Manrope, Arial, sans-serif"
        fontSize={760}
        fontWeight={700}
        fill={`url(#${gradientId})`}
      >
        S
      </text>
    </svg>
  );
}
